export enum TagSize {
  Default = '',
  Small = 'small',
  XSmall = 'xsmall'
}
